/**
 * Why Shop With Us – LiveChat open helper
 * Opens custom live-chat dialog or default LiveChatWidget on Start Chat.
 */
(() => {
  const openLiveChat = (event) => {
    const trigger = event.target.closest('[data-why-shop-livechat]');

    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const settings = window._theme?.settings;
    const liveChatType = settings?.livechat_type;
    const liveChatEnabled = settings?.livechat_enable;

    if (!liveChatEnabled) return;

    if (liveChatType === 'default') {
      if (window.LiveChatWidget) {
        window.LiveChatWidget.call('maximize');
      }

      return;
    }

    const liveChat = document.querySelector('live-chat');

    if (!liveChat) return;

    liveChat.classList.remove('hidden');

    if (typeof liveChat.openChatModal === 'function') {
      const dialog = liveChat.elements?.chatModal || liveChat.querySelector('dialog');

      liveChat.elements = liveChat.elements || {};
      liveChat.elements.chatModal = dialog;
      liveChat.elements.openChatModalBtns = document.querySelectorAll('[data-livechat-trigger]');

      if (dialog?.hasAttribute('open')) return;

      liveChat.openChatModal(event);

      return;
    }

    const primaryTrigger = liveChat.querySelector('aside [data-livechat-trigger]');

    if (primaryTrigger && primaryTrigger !== trigger) {
      primaryTrigger.click();

      return;
    }

    const dialog = liveChat.querySelector('dialog');

    if (!dialog) return;

    if (typeof dialog.show === 'function') {
      dialog.show();
    } else {
      dialog.setAttribute('open', true);
    }
  };

  document.addEventListener('click', openLiveChat, true);
})();
